import P2Regular from 'components/typography/P2Regular';
import { DeviceRow } from 'components/tables/data/device/types';

/**
 * Column for the external Id.
 */
export default function ExternalIdColumn({ data: { externalId } }: { data: DeviceRow }) {
  return <P2Regular lineClamp={3}>{externalId}</P2Regular>;
}
